import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

/**
 * Fetches pending case counts grouped by stakeholder type.
 * GET /api/Onboarding/dashboard-counts
 *
 * Response shape:
 * {
 *   success: true,
 *   data: {
 *     servicePartnerPendingCount: number,
 *     clientPendingCount: number,
 *     authorizerPendingCount: number,
 *   }
 * }
 *
 * @returns {{ success: boolean, data?: object, message?: string }}
 */
export const fetchDashboardCountsAction = async () => {
  try {
    const response = await apiClient.get(ATP_API_URL.DASHBOARD_COUNTS);

    if (response?.status === 200 && response.data?.success) {
      return {
        success: true,
        data: response.data.data || {},
        message: response.data.message || "",
      };
    }

    return {
      success: false,
      data: {},
      message: response?.data?.message || "Failed to fetch dashboard counts",
    };
  } catch (error) {
    console.error("[DashboardCounts] error:", error);
    return {
      success: false,
      data: {},
      message:
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch dashboard counts",
    };
  }
};
